import auditbmzl from './audit-bmzl'
import marginView from './margin-view'
export default {
    path: 'toubiao',
    component: () => import(/*webpackChunkName: 'bidding-toubiao'*/ '@layout/empty'),
    children: [
        auditbmzl,
        marginView
    ]
}